import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, ParamMap, RouterModule } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { SidenavComponent } from '../../components/sidenav/sidenav.component';
import { FrnFilingHeaderComponent } from '../../../modules/application/frn-filing/shared/components/frn-filing-header/frn-filing-header.component';
import { ApplicationFooterComponent } from '../../components/fcc-601/footer/application-footer.component';
import { MasqueradeHeaderComponent } from '../../components/masquerade-header/masquerade-header.component';
import { LoadingComponent } from '../../components/loading/loading.component';
import { LoadingService } from '../../../core/services/loading/loading.service';
import { ApplicationFormControlManagerService } from '../../../modules/application/shared/services/application-form-control-manager/application-form-control-manager.service';
import { ReadOnlyWarningModalService } from '../../../modules/application/shared/services/read-only-warning-modal/read-only-warning-modal.service';
import { ReadOnlyWarningType } from '../../../modules/application/shared/constants/read-only-warning-type-enum';
import { FrnFilingActionBarComponent } from '../../../modules/application/frn-filing/shared/components/frn-filing-action-bar/frn-filing-action-bar.component';
import { ApplicationNavigationStepsComponent } from '../../components/fcc-601/navigation-steps/application-navigation-steps.component';
import { UserStateService } from '../../../modules/user/shared/services/user-state/user-state.service';
import { UserRole } from '../../../core/enums/users/role';
import { Subject, takeUntil, tap } from 'rxjs';

@Component({
    selector: 'app-frn-filing-application-layout',
    standalone: true,
    templateUrl: './frn-filing-application-layout.component.html',
    styleUrls: ['./frn-filing-application-layout.component.scss'],
    imports: [
        RouterModule,
        SidenavComponent,
        FrnFilingHeaderComponent,
        ApplicationFooterComponent,
        FrnFilingActionBarComponent,
        ApplicationNavigationStepsComponent,
        MasqueradeHeaderComponent,
        AsyncPipe,
        LoadingComponent,
    ],
})
export class FrnFilingApplicationLayoutComponent implements OnInit, OnDestroy {
    private readonly loadingService = inject(LoadingService);
    private readonly applicationFormControlManager = inject(
        ApplicationFormControlManagerService,
    );
    private readonly readOnlyWarningModalService = inject(
        ReadOnlyWarningModalService,
    );
    private readonly userStateService = inject(UserStateService);
    private readonly route = inject(ActivatedRoute);
    private readonly destroy$ = new Subject<void>();

    loading$ = this.loadingService.loading$;

    ngOnInit(): void {
        this.route.firstChild?.paramMap
            .pipe(
                takeUntil(this.destroy$),
                tap((params: ParamMap) => {
                    const applicationId = params.get('id');

                    if (
                        applicationId &&
                        this.applicationFormControlManager.isReadOnly()
                    ) {
                        const isEwaStaff =
                            this.userStateService.getRole() !==
                            UserRole.Customer;

                        this.readOnlyWarningModalService.showIfNotAlreadyOpen(
                            isEwaStaff
                                ? ReadOnlyWarningType.Staff
                                : ReadOnlyWarningType.FrnRequest,
                        );
                    }
                }),
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
